import {Tab} from 'react-admin';

const TabMod = props => {
    return (<Tab {...props} />);
};

export default TabMod;